import AOS from 'aos'
import Lenis from 'lenis'
import './navigation.js'
import './form-changing-links.js'
import './contact-form-popup.js'
import './forms.js'
import './footer.js'

window.addEventListener('DOMContentLoaded', () => {
	// Smooth scrolling
	let lenis = new Lenis({
		autoRaf: true,
		anchors: {
			offset: -80
		},
	})

	AOS.init({
		duration: 1000,
		once: true,
		offset: 30,
	})

	setTimeout(() => {
		AOS.refresh()
	}, 200)
})
